export const BASE_URL = process.env.REACT_APP_API_URL;
export const IMAGE_URL = process.env.REACT_APP_IMAGE_URL;
export const HR_BASE_URL = process.env.REACT_APP_HR_BASE;
export const INTERVIEW_URL =
  process.env.REACT_APP_INTERVIEW_URL || "https://interview.nhwm.in/";